import * as R from 'remeda';
import { BackendFlags } from '../../../types/organizationGroupFeatures';

/** Mirrors the range the backend validates `refreshIntervalSeconds` against. */
export const DASHBOARD_REFRESH_MIN_SECONDS = 3;
export const DASHBOARD_REFRESH_MAX_SECONDS = 15;

/**
 * Resolves the `dashboardRefresh` feature toggle into a polling interval in
 * milliseconds, or `undefined` when it carries no usable override - in which
 * case each call site keeps its own default interval.
 */
export const resolveDashboardRefreshInterval = (
  dashboardRefresh: BackendFlags['dashboardRefresh']
): number | undefined => {
  if (!dashboardRefresh?.enabled) {
    return undefined;
  }

  const seconds = dashboardRefresh.refreshIntervalSeconds;

  if (typeof seconds !== 'number' || !Number.isFinite(seconds)) {
    return undefined;
  }

  return (
    R.clamp(seconds, {
      min: DASHBOARD_REFRESH_MIN_SECONDS,
      max: DASHBOARD_REFRESH_MAX_SECONDS,
    }) * 1000
  );
};
